import { post, put } from '../request'

export const createDelivery = (params) => post('api/deliveries', params)
export const createDeliveryFile = (params) => post('api/delivery-files', params)
export const removeDeliveryFile = (fileId, data) => put(`api/delivery-files/${fileId}`, data)
